import { Delta } from 'quill/core';
import type { ApolloClient } from '@apollo/client';
import { gql } from '../../graphql/generated/gql';
import getHeaderTitle from './getHeaderTitle';
import { parseMentionId } from './matchMention';

const POST_CONTENT_QUERY = gql(/** @complexity 9 */ `
  query fetchPostAnchorTitlePost($id: ID!) {
    post(id: $id) {
      id
      content(isLatest: true) {
        id
        delta
      }
    }
  }
`);

async function fetchPostAnchorTitle(
  apollo: ApolloClient<unknown>,
  postMentionId: string,
) {
  const { id, anchor } = parseMentionId(postMentionId);
  if (!anchor) return null;

  let content;
  try {
    const { data } = await apollo.query({
      query: POST_CONTENT_QUERY,
      variables: { id },
      fetchPolicy: 'network-only',
    });
    content = data?.post?.content.delta;
  } catch (err) {
    return null;
  }

  const headerTitle = content && getHeaderTitle(new Delta(content), anchor);
  return typeof headerTitle === 'string' && headerTitle.trim()
    ? headerTitle
    : null;
}

export default fetchPostAnchorTitle;
